import(/* webpackMode: "eager" */ "/vercel/path0/apps/customer-frontend/app/template.tsx");
